import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Temporal } from '@js-temporal/polyfill';

import { PRODUCT_INFO } from '@hsc/common/constants/product-info';

@Component({
  selector: 'hsc-footer',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="bolt-footer">
      <div class="bolt-container">
        <div class="bolt-footer__head">
          <div class="bolt-footer__intro">
            <div class="bolt-footer__logo">
              <bolt-logo color="white" href="/"></bolt-logo>
            </div>
            <div class="bolt-footer__phone">
              <span>{{ productInfo.phone }}</span>
            </div>
          </div>
        </div>
        <div class="bolt-footer__body">
          <div class="bolt-footer__content">
            <p>
              The Nationwide {{ productInfo.name }} ("Plan") is not an insurance product. The Plan's obligations are not
              provided by, and the Plan is not administered by, Nationwide Mutual Insurance Company or its affiliated or
              subsidiary companies. The Plan is administered by Axiom Product Administration, Inc. and the Plan's
              contractual obligations are provided solely by the applicable Axiom entity. For any questions, service
              under the Plan, or product information regarding the Nationwide {{ productInfo.name }}, please contact
              Axiom Product Administration at {{ productInfo.phone }}. Nationwide and the Nationwide N and Eagle are
              service marks of Nationwide Mutual Insurance Company, used under license.
            </p>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class Footer {
  readonly productInfo = PRODUCT_INFO;
  readonly year = Temporal.Now.plainDateISO().year;
}
